import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Header from '../../Requirement/components/layout/Header';
import { useLoading } from '../../../context/LoadingContext';
import SidebarBuyer from "../../Requirement/components/layout/BuyerSidebarnew";
import CompareOffer from "./CompareOffer";
import "../../../styles/requirement.css";
import "../../../styles/general.css";
import "../../../styles/buyer.css";

import "../../../styles/requirement.css";
import "../../../styles/general.css";
import "../../../styles/buyer.css";
import BrouseProducts from "./BrouseProducts";
import MarketInsight from "../../../components/common/MarketInsights";
import BankInsight from "../../../components/common/BankInsights";

const DiscoverEvaluate = () => {
    const [activeUser, setActiveUser] = useState("");
    const [activeTab, setActiveTab] = useState("Browse Products"); // Set default back to Browse Products
    const { setLoading } = useLoading();
    const navigate = useNavigate();

    const tabs = ["Browse Products", "Compare Offers","Market Insights","Bank Insights"];

    useEffect(() => {
        const checkUser = async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                const token = user.signInUserSession.idToken.jwtToken;
                const decodedToken = jwtDecode(token);
                const groups = decodedToken["cognito:groups"] || [];
                if (!groups.includes("AMTPL_BUYERS")) {
                    await Auth.signOut();
                    navigate("/login/buyer");
                } else {
                    setActiveUser(user.attributes.email);
                }
            } catch (error) {
                await Auth.signOut();
                navigate("/login/buyer");
            }
        };
        checkUser();
    }, [navigate]);

    const renderTabContent = () => {
        switch (activeTab) {
            case "Browse Products":
                return <BrouseProducts />;
            case "Compare Offers":
                return <CompareOffer />;
            case "Market Insights":
                return <MarketInsight />;
            case "Bank Insights":
                return <BankInsight />;
            default:
                <BrouseProducts />;
        }
    };

    return (
        <div className="buyer-layout">
           
            <div className="amtpl-tabs">
               
                <div className="content3">
                    <main className="main-content">
                        <div className=" main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${
                                        activeTab === tab
                                            ? "active"
                                            : "notactive"
                                    }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default DiscoverEvaluate;